import { getVideos, deleteVideo } from "../../../api/files";

export default {
  async getVideos({ commit }, payload) {
    return getVideos(payload)
      .then(res => {
        commit('setVideos', res.data.videos);
        commit('setTotalVideos', res.data.total);
        if (res.data.videos.length < 20) {
          commit('setAllVideosLoaded', true);
        }
      })
  },
  async getFilteredVideos({ commit }, payload) {
    return getVideos(0, 100, payload)
      .then(res => {
        commit('setFilteredVideos', res.data.videos);
        commit('setTotalVideos', res.data.total);
      })
  },
  async refreshVideoList({ commit }, payload) {
    return getVideos(payload)
      .then(res => {
        commit('resetVideos', res.data.videos);
        commit('setTotalVideos', res.data.total);
      })
  },
  async deleteVideo({ commit }, payload) {
    return deleteVideo(payload)
      .then(() => {
        commit('removeVideo', payload);
      })
  },
  addSelectedVideo({ commit }, payload) {
    commit('addSelectedVideo', payload);
  },
  removeSelectedVideo({ commit }, payload) {
    commit('removeSelectedVideo', payload);
  },
  clearSelectedVideos({ commit }) {
    commit('clearSelectedVideos')
  },
}
